import Filter from './modules/filter';

const filters = document.querySelectorAll('.filters');



if (filters.length > 0) {

  filters.forEach(() => {
    let options = {
      filtersName: ['categories'],
      filtersWrapper: '.module-archive .filters',
      cards: '.module-archive .cards .card',
    };
    new Filter(options);
  })
}


// WEBPACK FOOTER //
// ./scripts/common.js